import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Picker from 'react-picker'
import 'react-picker/css/picker.css'

export default class TimePicker extends React.PureComponent {

    render() {
        const { hh, mm, marginTop, marginLeft, _handleChange } = this.props

        return (
            <div style={{ display: 'flex', flexDirection: 'row', marginLeft, marginTop }} >
                <DropdownTime options={hours} value={hh} onChange={_handleChange('hh')} />
                <p style={{ marginLeft: 2, marginRight: 2, paddingTop: 4 }} >{' : '}</p>
                <DropdownTime options={minute} value={mm} onChange={_handleChange('mm')} />
                <p style={{ marginLeft: 4, paddingTop: 5 }} > น. </p>
            </div>
        )
    }

}


class DropdownTime extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            fruit: ''
        }
    }


    _handleClick = (e) => {
        this.refs.selection.show()
    }

    render() {

        const { value } = this.props
        return (

            <Picker
                ref="selection"
                {...this.props}
            >

                <OptionBox value={value} onClick={this._handleClick} />

            </Picker>
        )
    }
}

class OptionBox extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            value: this.props.value || '00'
        }

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value || '00'
        })
    }

    render() {

        return (
            <p className="control has-icons-right">
                <input className='input' onClick={this._handleClick} onChange={(e) => this.props.onClick(e)} value={this.state.value} readOnly />
                <span className="icon is-small is-right has-text-success" style={{ zIndex: 0 }} >
                    <i className="fas fa-caret-down"></i>
                </span>
            </p>

        )
    }
    _handleClick = (e) => {
        this.props.onClick && this.props.onClick(e)
    }
}



const hours = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
]

const minute = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
]


// WEBPACK FOOTER //
// ./src/components/Regular/TimePicker.js